
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"; 
import { SignInButton, useUser } from '@clerk/clerk-react';
import api from '../axios/axios';  // Import axios for making API calls
import { useDispatch } from "react-redux";
// import Spinner from "../utils/Spinner";
import Navbar from "../components/Navbar";
import Whychoose from "../components/home/Whychoose";
// import Testimonials from "../components/home/Testimonials";
import Footer from "../components/Footer";
import { signInSuccess } from "../redux/features/auth/userSlice";
// import ellvy from "../assets/Logo-full_2_fbwhsh.png"

const GoogleLogin = () => {
  const navigate = useNavigate();
  const dispatch=useDispatch()
  const { user, isSignedIn, isLoading } = useUser();
  const [loadingData, setLoadingData] = useState(false);
  const [error, setError] = useState(null);

  // Handle user sign-in effect and fetch user data after login
  useEffect(() => {
    if (isSignedIn && user) {
      const fetchUserData = async () => {
        setLoadingData(true);
        try {
          const response = await api.post('user/loginClerk', { user });
          setLoadingData(false);
          dispatch(signInSuccess(response.data.user));
          navigate('/');
        } catch (error) {
          setLoadingData(false);
          setError(error.response?.data?.message || "Something went wrong");
        }
      };
  
      fetchUserData();
    }
  }, [isSignedIn, user, navigate]); // Dependencies: runs when user or isSignedIn changes

//   if (isLoading || loadingData) {
//     return <div><Spinner/></div>;  // Show loading state until the user data is loaded
//   }

  if (error) {
    return <div>Error: {error}</div>;  // Display error message if the API request fails
  }

  return (
    <>
     <Navbar />

{/* Hero Section */}
<div className="flex items-center justify-center pt-14 ">
  <div className="bg-white p-10 rounded-xl shadow-2xl max-w-lg w-full text-center">
    <h1 className="text-4xl font-extrabold text-gray-800 mb-6">
      Welcome to <span className="text-indigo-600">VALUE BLINDS</span>
    </h1>

    <p className="text-md text-gray-600 mb-8 leading-relaxed">
      Your one-stop solution for elegant home decor. Please sign in to
      explore a world of possibilities.
    </p>

    {/* Illustration */}
    <img
      src={"https://res.cloudinary.com/dhhsupcai/image/upload/v1726647751/thrd6ytbgmj5fdvlphd7.png"||"https://via.placeholder.com/150"}
      alt="Home Decor"
      className="w-42 h-32 mx-auto mb-6"
    />

    {/* Sign-In Button */}
    <SignInButton provider="google">
      <button className="w-full py-3 px-6 bg-indigo-600 text-white text-lg font-semibold rounded-lg shadow-lg transform transition-transform hover:scale-105 hover:bg-indigo-700 active:scale-95">
        <div className="flex items-center justify-center">
          <svg
            className="w-5 h-5 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1.75-9h-3.5V7h-2v6h5.75V13h-3.5v-1z"
            />
          </svg>
          Sign in/Sign up
        </div>
      </button>
    </SignInButton>
  </div>
</div>

{/* Features Section */}
<div className="bg-gray-50 py-16">
  <div className="container mx-auto px-6">
    <Whychoose />
  </div>
</div>

{/* Testimonials Section */}
{/* <div className="bg-gray-100 py-16">
  <div className="container mx-auto px-6">
    <Testimonials />
  </div>
</div> */}

{/* Footer */}
<Footer />
</>
  );
};

export default GoogleLogin;